webpackJsonp([62383220246841],{

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "zelfstandig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mnl/vrl"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onz"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quis"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quid"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quid"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "bor-bot col" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "iemand"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "iets"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje gaat hetzelfde als het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "vragend-voornaamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "quis/quid"
	          )
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "bijvoeglijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qua"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quod"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quem"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quam"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quod"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qua"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qui"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quarum"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorum"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quos"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quas"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            "ali\u2013",
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            "ev ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "een of andere"
	            ),
	            " \xA0\xA0\xA0 mv ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "sommige"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje lijkt erg op het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "vragend-voornaamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "qui/quae/quod"
	          )
	        ),
	        ". Alleen de nominativus enkelvoud vrouwelijk wijkt af (",
	        _react2.default.createElement(
	          "i",
	          null,
	          "\u2013qua"
	        ),
	        " in plaats van ",
	        _react2.default.createElement(
	          "i",
	          null,
	          "\u2013quae"
	        ),
	        ")."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "zelfstandig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mnl/vrl"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onz"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quis"
	            ),
	            "\u2013quam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quic"
	            ),
	            "\u2013quam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013quam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013quam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013quam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013quam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quem"
	            ),
	            "\u2013quam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quic"
	            ),
	            "\u2013quam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013quam"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013quam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "iemand"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "iets"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje gaat hetzelfde als het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "vragend-voornaamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "quis/quid"
	          )
	        ),
	        ". Alleen de nominativus en accusativus enkelvoud onzijdig wijkt af (",
	        _react2.default.createElement(
	          "i",
	          null,
	          "quic\u2013"
	        ),
	        " in plaats van ",
	        _react2.default.createElement(
	          "i",
	          null,
	          "quid\u2013"
	        ),
	        ")."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "bijvoeglijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qui"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quod"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quen"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quan"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quod"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qua"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qui"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorun"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quarun"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorun"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quos"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quas"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013dam"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013dam"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            "ev ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "een of andere"
	            ),
	            " \xA0\xA0\xA0 mv ",
	            _react2.default.createElement(
	              "i",
	              null,
	              "sommige"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje lijkt erg op het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "vragend-voornaamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "qui/quae/quod"
	          )
	        ),
	        ", met \xE9\xE9n verschil: vormen die op ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "-m"
	        ),
	        " eindigen, krijgen een",
	        " ",
	        _react2.default.createElement(
	          "b",
	          null,
	          "-n"
	        ),
	        " (dus: ",
	        _react2.default.createElement(
	          "i",
	          null,
	          "quam"
	        ),
	        " \u2192 ",
	        _react2.default.createElement(
	          "i",
	          null,
	          "quandam"
	        ),
	        ")."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 2 },
	            "zelfstandig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mnl/vrl"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onz"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quis"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quid"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quem"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quid"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "iedereen"
	            )
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "alles"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje gaat hetzelfde als het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "vragend-voornaamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "quis/quid"
	          )
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "table" },
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "th",
	            { colSpan: 3 },
	            "bijvoeglijk"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col bor-bot" }),
	          _react2.default.createElement(
	            "th",
	            null,
	            "mannelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "vrouwelijk"
	          ),
	          _react2.default.createElement(
	            "th",
	            null,
	            "onzijdig"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quis"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quod"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cuius"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "cui"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quem"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quam"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quod"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. ev."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qua"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quo"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "nom. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "qui"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "gen. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorum"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quarum"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quorum"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "dat. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col" },
	            "acc. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quos"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quas"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            null,
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quae"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement(
	            "th",
	            { className: "col bor-bot" },
	            "abl. mv."
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013que"
	          ),
	          _react2.default.createElement(
	            "td",
	            { className: "bor-bot" },
	            _react2.default.createElement(
	              "strong",
	              null,
	              "quibus"
	            ),
	            "\u2013que"
	          )
	        ),
	        _react2.default.createElement(
	          "tr",
	          null,
	          _react2.default.createElement("th", { className: "col" }),
	          _react2.default.createElement(
	            "td",
	            { colSpan: 3, className: "center" },
	            _react2.default.createElement(
	              "i",
	              null,
	              "iedere, elke"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        _Letop2.default,
	        null,
	        "Dit rijtje lijkt erg op het rijtje van",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "vragend-voornaamwoord" },
	          _react2.default.createElement(
	            "b",
	            null,
	            "qui/quae/quod"
	          )
	        ),
	        ". Alleen de nominativus enkelvoud mannelijk wijkt af (",
	        _react2.default.createElement(
	          "i",
	          null,
	          "quis\u2013"
	        ),
	        " in plaats van ",
	        _react2.default.createElement(
	          "i",
	          null,
	          "qui\u2013"
	        ),
	        ")."
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TableSelector = __webpack_require__(28);
	
	var _TableSelector2 = _interopRequireDefault(_TableSelector);
	
	var _onbepVnw = __webpack_require__(653);
	
	var _onbepVnw2 = _interopRequireDefault(_onbepVnw);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = [{
	  les: "46",
	  table: _onbepVnw2.default
	}];
	
	exports.default = function () {
	  return _react2.default.createElement(_TableSelector2.default, {
	    defaultChapter: "46",
	    data: data,
	    title: "Onbepaald voornaamwoord"
	  });
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spqr-rijtjes-onbepaald-voornaamwoord-js-6628ad2a1df724322976.js